/**
 * Hard end date for the launch price. No countdown on the page ever runs past
 * it, and when it passes every countdown block collapses gracefully.
 */
export const LAUNCH_DEADLINE = '2026-09-30T23:59:00-04:00';

/** Human-readable form of LAUNCH_DEADLINE, shown next to the countdown. */
export const LAUNCH_DEADLINE_LABEL = 'Wednesday, September 30, 2026, 11:59pm ET';

/** Hours each visitor gets at the launch price, from their first visit. */
export const LAUNCH_WINDOW_HOURS = 24;

export const CHECKOUT_URL = 'https://screen-and-adapt-yoga.impultienda.ar/checkout';
